import { render, staticRenderFns } from "./studyChatModalAttation.vue?vue&type=template&id=f6f63a14&scoped=true&"
import script from "./studyChatModalAttation.vue?vue&type=script&lang=js&"
export * from "./studyChatModalAttation.vue?vue&type=script&lang=js&"
import style0 from "./studyChatModalAttation.vue?vue&type=style&index=0&id=f6f63a14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f63a14",
  null
  
)

export default component.exports